import { render } from "./GameScreen.vue?vue&type=template&id=3cec8be4"
import script from "./GameScreen.vue?vue&type=script&lang=js"
export * from "./GameScreen.vue?vue&type=script&lang=js"

import "./GameScreen.vue?vue&type=style&index=0&id=3cec8be4&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\Dont Get Got\\dont-get-got\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__